import { render, staticRenderFns } from "./CardStyle5.vue?vue&type=template&id=a6924ea4&scoped=true&"
import script from "./CardStyle5.vue?vue&type=script&lang=js&"
export * from "./CardStyle5.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle5.vue?vue&type=style&index=0&id=a6924ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6924ea4",
  null
  
)

export default component.exports